import { color, Icon } from '@primer-io/goat'
import * as ArticleComponents from 'components/ArticleComponents'
import IconCarousel from 'components/IconCarousel'
import { FullWidthGuide, GuideLink, Header, OverviewSection, OverviewTopSection } from 'components/OverviewComponents'
import Tabs, { Tab } from 'components/Tabs'
import Grid from 'ds/Grid'
import React from 'react'
import styled from 'styled-components'
import breakpoints from '../../../theme/breakpoints'
//import CoverImg from './assets/cover.png'
import ReconWithPrimerImg from './assets/recon.png'
import ReportContentImg from './assets/report_content.png'
import SupportedProcessorsImg from './assets/supported_processors.png'
//import { useCases, workflowApps } from './data'

///////////////////////////////////////////
// Root
///////////////////////////////////////////



export default function ReconciliationOverview() {
	return (
		<ArticleComponents.Wrapper>
			<OverviewSection>
				<OverviewTopSection
					title='Reconciliation'
					description={
						<>
							<ArticleComponents.P>
                            To avoid having to consume different settlement reports across all your providers, Primer's settlement reports transforms these into one unified format for your convenience.
							</ArticleComponents.P>
						</>
					}
					
				/>
			</OverviewSection>

            <OverviewSection>
				<FullWidthGuide
					title='Reconciliation with Primer'
					description='Learn how we transform third-party settlement reports into one unified format.'
					imgBackground={color('yellow-200')}
					imgSrc={ReconWithPrimerImg}
					buttonContent='Get started'
					to='./unified-settlement-report'
				/>
			</OverviewSection>
			<OverviewSection>
				<FullWidthGuide
					title='Report content'
					description='Describing the data made available in the unified settlement reports.'
					imgBackground={color('indigo-100')}
					imgSrc={ReportContentImg}
					buttonContent='Learn more'
					to='./report-content'
				/>
			</OverviewSection>
			
			<OverviewSection>
				<FullWidthGuide
					title='Supported processors'
					description='List of supported processors and the settlement reports we have integrated.'
					imgBackground={color('green-200')}
					imgSrc={SupportedProcessorsImg}
					buttonContent='Learn more'
					to='./supported-processors'
				/>
			</OverviewSection>
			
		</ArticleComponents.Wrapper>
	)
}
